export const socialMediaLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61563119281020',
    youtube: 'https://www.youtube.com/@enduroconnaction-radusa',
    instagram: 'https://www.instagram.com/enduro_connection_radusa_/',
    tiktok: 'https://www.tiktok.com/@enduro_connection_radusa',
} as const;
